import { QuotationRequestViewModel } from '@hec/models';

export const REQUEST_QUOTATION = 'REQUEST_QUOTATION';

export const requestQuotation = (requestQuotation: QuotationRequestViewModel) => ({
  type: REQUEST_QUOTATION,
  data: requestQuotation,
});
